"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFalsy = isFalsy;
function isFalsy(text, additionalFalsyValues = []) {
    const defaultFalsyValues = ['', '0', 'false', 'no', 'nil', 'none', 'n/a', 'undefined', 'null', 'off'];
    const falsyValues = [...defaultFalsyValues, ...additionalFalsyValues.map((v) => v.toLowerCase())];
    return falsyValues.includes(String(text).trim().toLowerCase());
}
//# sourceMappingURL=utils.js.map